import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/esm/toConsumableArray";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Fragment = React.Fragment;
var regex = /<([^\/.]+?)(?:\s*|\s+[^\/\>]+)>(.*?)<\/\1>|<([^\/.]+?)(?:\s*|\s+[^\/\>]+)\/>/;

var Interpolate = function Interpolate(_ref) {
  var _context;

  var text = _ref.text,
      components = _ref.components;
  return ___EmotionJSX(React.Fragment, null, _reduceInstanceProperty(_context = text.split(regex)).call(_context, function (_ref2, v, k) {
    var _context2, _context3, _context4;

    var tree = _ref2.tree,
        component = _ref2.component;

    switch (k % 4) {
      case 0:
        return {
          tree: _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(tree), [___EmotionJSX(Fragment, {
            key: k
          }, v)])
        };

      case 1:
        return {
          tree: tree,
          component: v
        };

      case 2:
        return {
          tree: component && components[component] ? _concatInstanceProperty(_context3 = []).call(_context3, _toConsumableArray(tree), [___EmotionJSX(Fragment, {
            key: k
          }, components[component](___EmotionJSX(Interpolate, {
            text: v,
            components: components
          })))]) : tree
        };

      case 3:
        return {
          tree: v && components[v] ? _concatInstanceProperty(_context4 = []).call(_context4, _toConsumableArray(tree), [___EmotionJSX(Fragment, {
            key: k
          }, components[v]())]) : tree
        };

      default:
        return {
          tree: tree
        };
    }
  }, {
    tree: []
  }).tree);
};

export default Interpolate;